module.exports = __webpack_public_path__ + "fonts/fa-solid-900.40e466986a41f3e0c329f64cdcaf8b9f.eot";